$(document).on('turbolinks:load', function () {
    (function () {
        function r(e, n, t) {
            function o(i, f) {
                if (!n[i]) {
                    if (!e[i]) {
                        var c = "function" == typeof require && require;
                        if (!f && c) return c(i, !0);
                        if (u) return u(i, !0);
                        var a = new Error("Cannot find module '" + i + "'");
                        throw a.code = "MODULE_NOT_FOUND", a
                    }
                    var p = n[i] = {exports: {}};
                    e[i][0].call(p.exports, function (r) {
                        var n = e[i][1][r];
                        return o(n || r)
                    }, p, p.exports, r, e, n, t)
                }
                return n[i].exports
            }

            for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) o(t[i]);
            return o
        }

        return r
    })()({
        1: [function (require, module, exports) {
            "use strict";
            var _main = require("./main.js"), _main2 = _interopRequireDefault(_main);

            function _interopRequireDefault(e) {
                return e && e.__esModule ? e : {default: e}
            }

            (0, _main2.default)();

        }, {"./main.js": 2}], 2: [function (require, module, exports) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {value: !0}), exports.default = function () {
                $(function () {
                    var a = $(".js-hmenu"), e = $(".m-headerDrop"), t = "is-active";
                    a.on("click", function () {
                        var a = $(this), e = a.attr("aria-controls");
                        return a.hasClass(t) ? (a.removeClass(t).attr("aria-expanded", "false"), $("#" + e).removeClass(t).attr("aria-hidden", "true")) : (a.addClass(t).attr("aria-expanded", "true"), $("#" + e).addClass(t).attr("aria-hidden", "false")), !1
                    }), $(document).click(function (s) {
                        $(s.target).closest(e).length || (a.removeClass(t).attr("aria-expanded", "false"), e.removeClass(t).attr("aria-hidden", "true"))
                    })
                }), $(function () {
                    var a = $(".js-toggle"), e = "is-active";
                    a.on("click", function () {
                        var a = $(this), t = a.attr("aria-controls");
                        return a.hasClass(e) ? (a.removeClass(e).attr("aria-expanded", "false"), $("#" + t).removeClass(e).attr("aria-hidden", "true").stop().slideUp(300)) : (a.addClass(e).attr("aria-expanded", "true"), $("#" + t).addClass(e).attr("aria-hidden", "false").stop().slideDown(300)), !1
                    })
                }), $(function () {
                    var a = window.navigator.userAgent.toLowerCase(), e = $(".js-lineClamp");
                    -1 != a.indexOf("msie") || -1 != a.indexOf("trident") ? e.length > 0 && e.find("span").each(function (a, e) {
                        $clamp(e, {clamp: 3})
                    }) : e.length > 0 && e.find("span").each(function (a, e) {
                        $clamp(e, {clamp: 2})
                    })
                }), $(function () {
                    $(".js-scroll");
                    $(document).on("click", ".js-scroll", function () {
                        var a = $(this).attr("href"), e = $("#" === a || "" === a ? "html" : a).offset().top;
                        return $("body, html").animate({scrollTop: e - 70}, 1e3, "easeInOutCubic"), !1
                    })
                }), $(function () {
                    var a = $(".js-modal"), e = $(".m-modal"), t = ($(".m-modalContent"), $(".js-modalClose")),
                        s = $("body"), n = "is-active", r = "is-fixed";
                    a.on("click", function () {
                        var a = $(this).attr("href");
                        return $(a).modalCreate(), !1
                    }), t.on("click", function () {
                        return e.removeClass(n).fadeOut(300).attr("aria-hidden", "true"), s.removeClass(r), !1
                    }), $(document).on("mousedown", function (a) {
                        $(a.target).closest(".m-modalContent").length || $(a.target).closest(".ui-menu-item").length || (e.removeClass(n).fadeOut(300).attr("aria-hidden", "true"), s.removeClass(r))
                    }), $.fn.modalCreate = function () {
                        var a = $(this), e = $(window).scrollTop();
                        a.addClass(n).css("top", e + 100).fadeIn(300).scrollTop(0).attr("aria-hidden", "false"), s.addClass(r)
                    }, $(document).on("keydown", function (a) {
                        27 === a.keyCode && (e.removeClass(n).fadeOut(300).attr("aria-hidden", "true"), s.removeClass(r))
                    })
                }), $(function () {
                    $(window).scroll(function (e) {
                        var a = $(".t-guide"), t = a.find(".m-listSlide__head"), s = a.find(".m-listSlide__body"), n = t.outerHeight(!0);
                        $(this).scrollTop() >= 20 ? (t.addClass("is-fixed"), s.css("padding-top", n)) : (t.removeClass("is-fixed"), s.css("padding-top", "0"))
                    }
                    );
                })
            };
        }, {}]
    }, {}, [1])
    var e = $(".m-navSlide__inner"), a = e.height();
    $(window).on("load resize", function () {
        var t;
        (t = $(window).height()) - 80 >= a ? e.css({
            height: "auto", "overflow-y": ""
        }
        ) : e.css({
            height: t - 80, "overflow-y": "scroll"
        })
    })
});
